/* eslint-disable react/react-in-jsx-scope */
import { ERROR_CODES } from './Errors';

const { FLEX_PROFESSIONAL_ERROR_CODES } = ERROR_CODES;

const MESSAGE_MAP = {
	[FLEX_PROFESSIONAL_ERROR_CODES.SUCCESS]:
		'This professional is new to our network. Continue creating their account to add them to your workforce.',
	[FLEX_PROFESSIONAL_ERROR_CODES.CONTACT_US]: (
		<>
			This email and/or cell phone number already exists for another professional. If you’re still having issues after
			checking both fields, contact your account manager for further assistance.
		</>
	),
	[FLEX_PROFESSIONAL_ERROR_CODES.ALREADY_EXISTS]: (
		<>
			This professional has already been added to your Workforce. Click on <strong>Back to Workforce</strong> to see
			them in your roster.
		</>
	)
};

export default MESSAGE_MAP;
